'use strict';
import Decimal from 'decimal.js';
Decimal.config({
  precision: 10,
  errors: false
});

const MINUTES_IN_HOUR = 60;
const MINUTES_IN_DAY = 24 * 60;
const MINUTES_IN_WEEK = 7 * 24 * 60;
const MINUTES_IN_MONTH = 30 * 24 * 60; // for storage purposes. proper date math will be used with specifying the duration. plus, we need to differentiate 4 weeks vs 1 month
const MINUTES_IN_YEAR = 365 * 24 * 60; // another storage approximation

const CONVERSIONS = {
  minutes: 1,
  hours: MINUTES_IN_HOUR,
  days: MINUTES_IN_DAY,
  weeks: MINUTES_IN_WEEK,
  months: MINUTES_IN_MONTH,
  years: MINUTES_IN_YEAR
};

export function getConversion(unit) {
  return CONVERSIONS[unit];
}

export function getDurationUnit(duration) {
  if (!duration) {
    return 'default'; // default case
  // } else if (duration >= MINUTES_IN_YEAR) {
  //   return 'years';
  // } else if (duration >= MINUTES_IN_MONTH) {
  //   return 'months';
  } else if (duration === 2 * MINUTES_IN_WEEK || duration === MINUTES_IN_WEEK) {
    return 'weeks';
  } else if (duration >= MINUTES_IN_DAY) {
    return 'days';
  } else if (duration >= MINUTES_IN_HOUR) {
    return 'hours';
  } else {
    return 'minutes'
  }
}

export function convertToMinutes(duration, unit) {
  if (!duration || !unit) {
    return duration;
  }
  const value = new Decimal(duration);
  const converter = new Decimal(CONVERSIONS[unit]);
  return Math.floor(value.times(converter).toNumber());
}

export function convertFromMinutes(duration, unit) {
  if (!duration || !unit) {
    return duration;
  }
  const value = new Decimal(duration);
  const converter = new Decimal(CONVERSIONS[unit]);
  return value.dividedBy(converter).toNumber();
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/TimeUtils.js